// use-navbar-state v1: 导航栏状态管理Hook

import React, { useState, useEffect } from 'react';

import { useAuth } from '../../../context/AuthContext';
import { useNotifications } from '../../../context/NotificationContext';

/**
 * 导航栏状态管理Hook
 * @param {Object} user - 当前用户对象（保留参数以保持向后兼容）
 * @returns {Object} 状态和设置函数
 */
const useNavbarState = user => {
  // 🔧 【性能优化】直接从 Context 获取未读计数，不再独立加载
  const { unreadCount } = useNotifications();

  // 从 AuthContext 获取当前用户
  const { user: currentUser } = useAuth();

  // 下拉菜单状态
  const [showDropdown, setShowDropdown] = useState(false);

  // 外部点击关闭下拉菜单
  useEffect(() => {
    const handleClickOutside = event => {
      if (showDropdown) {
        // 这里需要外部传入ref，暂时用简单逻辑
        const target = event.target;
        const isNavbarClick = target.closest('[data-navbar-dropdown]');
        if (!isNavbarClick) {
          setShowDropdown(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown]);

  return {
    // 状态
    unreadCount, // 🔥 直接从 NotificationContext 获取
    currentUser, // 从 AuthContext 获取的用户
    showDropdown,

    // 设置函数
    setShowDropdown,

    // 操作函数（保留接口以保持向后兼容，但不再需要 loadUnreadCount）
    loadUnreadCount: () => {
      // 空函数，保持向后兼容
      console.warn(
        '[useNavbarState] loadUnreadCount is deprecated, use NotificationContext instead'
      );
    },
    toggleDropdown: () => setShowDropdown(!showDropdown),
    closeDropdown: () => setShowDropdown(false),
  };
};

export default useNavbarState;
